import { KlaviyoUserCartDetails } from "@/components/common/Klaviyo";
import { generalConstants } from "@/utils/constants";
import { addProductToCart } from "./cartHelpers";
import { setGroupShipDate, setEstimatedShip } from "./checkout-shipping/checkoutShippingHelper";
import { checkIfFastShippingVariant } from "./pdpHelpers/pdpVariantHelpers";

export const pushAddToCartEvent = async (data,selectedVariant,logUser,productURL,actionList='Add To Cart') => {
  let fastShippingVariant = checkIfFastShippingVariant(selectedVariant)
  let wishlistUrl = window.location.href?.includes("wishlist") ? true : false;
  let oliSearch = (window.location.search?.includes("search_source=oli_plp") || window.location.search?.includes("search_source=oli_pdp")) ? true: false;
  let gau_category = wishlistUrl ? 'Shared wishlist - add to cart':
                      actionList == 'Quick Buy Add to Cart' && fastShippingVariant ? `${oliSearch ? 'OLI -' : ''} PLP -  fast shipping quick buy`:
                     actionList == 'Quick Buy Add to Cart' ? `${oliSearch ? 'OLI -' : ''} PLP - quick buy`:
                     actionList == 'PDP - Buy now'? "PDP - Buy now add to cart":
                     actionList == 'PDP - Add custom item to bag' ? `${oliSearch ? 'OLI -' : ''} PDP - Add custom item to bag`: 
                     actionList == 'PDP - fast shipping add to cart' ? `${oliSearch ? 'OLI -' : ''} PDP - fast shipping add to cart`: `${oliSearch ? 'OLI - ' : ''} PDP - add to cart`;
//userproperties variables 
var userProperties;
let list = document?.location?.pathname
if(logUser?.userLoggedIn && (logUser?.userLoggedIn?.email || logUser?.userData?.email)){
  userProperties = {
    customer_email: logUser?.userData?.email ? logUser?.userData?.email : logUser?.userLoggedIn?.email,
    customer_id: logUser?.userData?.id ? logUser?.userData?.id : logUser?.userLoggedIn?.id,
    visitor_type: "logged_in"
  }
}

else{
  userProperties = {
    visitor_type: "guest"
  }
}


  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
          'event': 'addToCart',
          'eec_category': 'Ecommerce',
				  'gau_category': gau_category,
          //'eec_label': actionList,
          'ecommerce': {
            'add': {
              // 'actionField': {
              //   'list': actionList
              // },
              'products': [{
                'name': data?.title,                      // Name or ID is required.
                'id': data.id.toString('ascii').replace("gid://shopify/Product/", ""),
                'price': data?.price,
                'brand': data?.vendor,
                'category': data?.productType,    //Category should be same as defined in productType
                'variant': selectedVariant?.title,
                'name-id': data?.title+' - '+data.id.toString('ascii').replace("gid://shopify/Product/", ""),
                'quantity': 1,
                'content_ids':selectedVariant?.sku,
						    'content_type': 'product',
                'product_type': data?.named_tags?.category,
               }]
             },
             'currencyCode': "USD"
           },
        });
        dataLayer.push({                          
          'event': 'fbAddToCart',
          'itemContentType': 'product',
          'itemContentIds': data.id.toString('ascii').replace("gid://shopify/Product/", "")
        });
        data.selectedVariant = selectedVariant.title
        data.sku = selectedVariant.sku
        data.compareAtPrice = (selectedVariant?.compareAtPriceV2?.amount == 0 || selectedVariant?.compareAtPriceV2?.amount == undefined) ? selectedVariant?.priceV2?.amount : selectedVariant?.compareAtPriceV2?.amount
        data.ImageURL = selectedVariant?.image?.url
        data.ProductURL = productURL
        KlaviyoUserCartDetails(data,logUser?.userData?.email)
        return true;
  }

  export const pushCartUpdateEvent = async (cart_list) => {
    const arr = []
      
      cart_list?.lineItems?.edges?.map((element)=>{
        var nodes={
            name:element?.node?.title,
            quantity:element?.node?.quantity,
            image:element?.node?.variant?.image?.src,
            price:element?.node?.variant?.priceV2.amount,
            final_price:element?.node?.variant?.priceV2?.amount * element?.node?.quantity,
            parent_id:element?.node?.parent_id
        }

        // if(data.title === element.node.title){
        //   nodes.parent_id = data.id
        // }
        arr.push(nodes)
       
      })
      dataLayer.push({                                
        'event': 'cartUpdate',
        'cart': {
          'cartId':cart_list?.id,
          'cartTotal':cart_list?.totalPrice,
          
          'cartproducts':arr
           
         },
        //  'eventCallback': function() {
        //    document.location = `/products`
        //  }
      });

     
      // dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      // dataLayer.push({
      //   'event': 'cartUpdate',
      //   'cart': {
      //     'cartId':cart_list.id,
      //     'cartTotal':cart_list.totalPrice,
          
      //     'cartproducts':cart_list?.lineItems?.edges
           
      //    },
      //   //  'eventCallback': function() {
      //   //    document.location = `/products`
      //   //  }
      // });
     return true; 
  }

  export const addToBag = async (selectedVariant,badgeCurated,productDetails,extraAtt) => {
    let request = {
        variantId: selectedVariant.id,
        quantity: "1",
      };
      if (selectedVariant.barcode) {
        request.lineItemCustomAttributes = [{ key: "_upc", value: selectedVariant.barcode.toString().replace('.00','') }];
      }
      if (productDetails?.vendor) {
        if(request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
          request.lineItemCustomAttributes.push({ key: "_vendor", value: productDetails.vendor });
        }
        else{
          request.lineItemCustomAttributes = [{ key: "_vendor", value: productDetails.vendor }];
        }
      }
      if(selectedVariant.olivela_cost) {
        if(request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
          request.lineItemCustomAttributes.push({ key: "_oc", value: selectedVariant.olivela_cost.value });
        }
        else{
          request.lineItemCustomAttributes = [{ key: "_oc", value: selectedVariant.olivela_cost.value }];
        }
      }
      let availabilityType = productDetails?.tags.includes(generalConstants.pre_order_tag) ?  generalConstants.pre_order : productDetails?.tags.includes(generalConstants.available_now_tag) ? generalConstants.available_now : '';
      if(availabilityType) {
        if(request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
          request.lineItemCustomAttributes.push({ key: "_availability", value: availabilityType });
        } else {
          request.lineItemCustomAttributes = [{ key: "_availability", value: availabilityType }];
        }
      } else {
        reportError("Add to cart: Product missing availability tag", productDetails?.id);
      }
      if(badgeCurated) {
        if(request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
          request.lineItemCustomAttributes.push({ key: "_badge_curated", value: badgeCurated });
        } else {
          request.lineItemCustomAttributes = [{ key: "_badge_curated", value: badgeCurated }];
        }
      }
      /* For delivery estimated date and ship date */
      let estimatedDeliveryDate = setGroupShipDate(selectedVariant);
      if (estimatedDeliveryDate.property) {
        request.lineItemCustomAttributes.push(estimatedDeliveryDate.property)
      }
      let expectedShipDate = setEstimatedShip(selectedVariant);
      if (expectedShipDate) {
        request.lineItemCustomAttributes.push(expectedShipDate)
      }

      if(extraAtt?.device) {
        request.lineItemCustomAttributes.push({ key: "_device", value: extraAtt?.device });
      }
      
      let response = await addProductToCart(request,productDetails);
      return response;
   
    
  }